import { buildReducer } from '../../../../shared';
import {
    dismissLeaveGroupDialogAction,
    leaveGroupConfirmClickedAction,
} from '../../../actions/user/groups/leaveGroupDialogActions';
import { leaveGroupClickedAction } from '../../../actions/data/groups/leaveGroupActions';

export default buildReducer<boolean>()
    .handle(leaveGroupClickedAction, (state, action) => {
        if (action.payload.groupKind == 3) {
            return false;
        }
        return true;
    })
    .handle(leaveGroupConfirmClickedAction, (state, action) => {
        return false;
    })
    .handle(dismissLeaveGroupDialogAction, (state, action) => {
        return false;
    })
    .done(false);
export type { Action } from '../../../../shared';
